import { Bars3BottomLeftIcon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { Tooltip } from 'antd'
import { MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import { Dialog, Menu, Transition } from '@headlessui/react'
import React, { Fragment, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { privatePages, privateGroups } from '../../routes/PrivateRouter'
import { assetsImg } from '../../utils/imgUtil'
import { setLastAccess } from '../../utils/lstorageUtil'
import { getAuth } from '../../api/apiUtil'
import { useAuth } from '../../hooks/useAuth'
import { useScreenSize } from '../../hooks/useScreenSize'
import { configType } from '../../types/configType'
import { Breadcrumb } from '../../components/Panel/Breadcrumb'

const imgPath_app = assetsImg('./app300.svg')

const userNavigation = [
  { name: 'Configuración', id: 1 },
  { name: 'Cerrar sesión', id: 2 },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const getLetterName = (name) => {
  let letter = ''
  const words = name.split(' ');
  if (words.length === 2)
    letter = words[0].charAt(0) + words[1].charAt(0)
  else if (words.length === 1)
    letter = words[0].charAt(0)
  return letter.toUpperCase()
}

export const Panel = (props) => {
  const { children, page: priv_page } = props

  const navigate = useNavigate()
  const { auth, setAuth } = useAuth()
  const { width, } = useScreenSize()
  const [paths, setPaths] = useState([])
  const [navigation, setNavigation] = useState([])
  const [currentNav, setCurrentNav] = useState(null)
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [sidebarName, setSidebarName] = useState(true)

  useEffect(() => {
    setSidebarName(width >= configType.responsiveLg)
  }, [width])

  useEffect(() => {
    let isMounted = true

    const priv_pages = privatePages
      .filter(page => page.order && (!page.code || (auth.ropag && auth.ropag.some(rp => rp === page.code))))
      .map(page => ({ ...page }))

    const data = getNavigation(priv_pages, privateGroups, priv_page.group)
    const curret_nav = data.find(page => page.current && page.href) || null

    if (isMounted) {
      setPaths(priv_pages)
      setNavigation(data)
      setCurrentNav(curret_nav)
    }

    return () => {
      isMounted = false
    }
    // eslint-disable-next-line
  }, [priv_page, auth])

  useEffect(() => {
    const divElement = document.getElementsByClassName("grecaptcha-badge")
    if (divElement && divElement.length > 0)
      divElement[0].parentElement.style.display = 'none'
  }, [])

  const getNavigation = (priv_pages, priv_groups, open_group) => {
    const data_no_group = priv_pages.filter(page => !page.group).map(page => ({
      name: page.pageName,
      href: '/panel' + page.path,
      icon: page.icon,
      current: !priv_page.group && page.pageName === priv_page.pageName,
      order: page.order,
      parent: null,
      group: null,
      open: false,
    }))

    const data_group = priv_groups.filter(page => !open_group || page.group === open_group).map(page => ({
      name: page.pageName,
      href: null,
      icon: page.icon,
      current: priv_page.group && page.group === priv_page.group,
      order: page.order,
      parent: null,
      group: page.group,
      open: open_group && page.group === open_group,
    }))

    const data_det_group = priv_pages.filter(page => open_group && page.group && page.group === open_group).map(page => ({
      name: page.pageName,
      href: '/panel' + page.path,
      icon: page.icon,
      current: priv_page.group && page.group === priv_page.group && page.pageName === priv_page.pageName,
      order: page.order,
      parent: data_group.find(p => p.group === page.group)?.name || null,
      group: null,
      open: false,
    }))

    const data = [...data_no_group, ...data_group, ...data_det_group]
    return data.sort((a, b) => a.order - b.order)
  }

  const handleProfile = (id) => {
    if (id === 1) {
      navigate('/panel/cfg/usuario', { replace: false })
    }
    else if (id === 2) {
      setAuth(getAuth(false))
      navigate('/login', { replace: true })
    }
  }

  const handleNavigate = (nav) => {
    setLastAccess()
    if (nav.href)
      navigate(nav.href)
    else if (nav.group)
      setNavigation(getNavigation(paths, privateGroups, (nav.open ? null : nav.group)))
  }

  const getButton = (item, sidebar) => (
    <button
      key={item.name}
      className={classNames(
        !item.open ? (item.current ? 'bg-indigo-800 text-white' : 'text-indigo-100 hover:bg-indigo-600') : 'bg-indigo-900 text-white',
        'w-full group flex items-center px-2 py-2 text-sm font-medium rounded-md'
      )}
      onClick={() => handleNavigate(item)}
    >
      <item.icon className="mr-3 h-6 w-6 flex-shrink-0 text-indigo-300" aria-hidden="true" />
      {sidebar && item.name}
    </button>
  )

  return (
    <>
      <div className='min-h-screen bg-gray-200'>

        {/* INI MENU LATERAL OCULTO */}
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog as="div" className="relative z-40 md:hidden" onClose={setSidebarOpen}>
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
            </Transition.Child>

            <div className="fixed inset-0 z-40 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-indigo-700 pt-5 pb-4">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute top-0 right-0 -mr-12 pt-2">
                      <button
                        type="button"
                        className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                        onClick={() => setSidebarOpen(false)}
                      >
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="flex flex-shrink-0 items-center px-4">
                    <img
                      className="h-8 w-auto"
                      src={imgPath_app}
                      alt="Titania"
                    />
                  </div>
                  <div className="mt-5 h-0 flex-1 overflow-y-auto">
                    <nav className="space-y-1 px-2">
                      {navigation.map((item) => (
                        <button
                          key={item.name}
                          className={classNames(
                            item.current ? 'bg-indigo-800 text-white' : 'text-indigo-100 hover:bg-indigo-600',
                            'w-full group flex items-center px-2 py-2 text-base font-medium rounded-md'
                          )}
                          onClick={() => handleNavigate(item)}
                        >
                          <item.icon className="mr-4 h-6 w-6 flex-shrink-0 text-indigo-300" aria-hidden="true" />
                          {item.name}
                        </button>
                      ))}
                    </nav>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
              <div className="w-14 flex-shrink-0" aria-hidden="true">
                {/* Dummy element to force sidebar to shrink to fit close icon */}
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/* FIN MENU LATERAL OCULTO */}

        {/* INI MENU LATERAL */}
        <div className={"hidden md:fixed md:inset-y-0 md:flex " + (sidebarName ? "md:w-64" : "md:w-16") + " md:flex-col"}>
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex flex-grow flex-col overflow-y-auto bg-indigo-700 pt-5">
            <div className="flex flex-shrink-0 items-center px-4">
              <img
                className="h-8 w-auto cursor-pointer"
                src={imgPath_app}
                alt="Titania"
                onClick={() => setSidebarName(!sidebarName)}
              />
            </div>
            <div className="mt-5 flex flex-1 flex-col">
              <nav className="flex-1 space-y-1 pl-2 pr-2.5 pb-4">
                {navigation.map((item, index) => sidebarName ?
                  getButton(item, sidebarName) :
                  <Tooltip key={index} title={item.name} placement='right'>
                    {getButton(item, sidebarName)}
                  </Tooltip>
                )}
              </nav>
            </div>
          </div>
        </div>
        {/* FIN MENU LATERAL */}

        {/* INI DIV BANNER & CONTENT */}
        <div className={"flex flex-1 flex-col min-h-screen " + (sidebarName ? "md:pl-64" : "md:pl-16")}>

          {/* INI DIV BANNER */}
          <div className="static lg:sticky top-0 z-10 flex h-16 flex-shrink-0 bg-white shadow">
            {/* BOTON OCULTO - Panel lateral oculto */}
            <button
              type="button"
              className="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
              onClick={() => setSidebarOpen(true)}
            >
              <span className="sr-only">Open sidebar</span>
              <Bars3BottomLeftIcon className="h-6 w-6" aria-hidden="true" />
            </button>
            {/* BANNER - Buscar, notificación y usuario */}
            <div className="flex flex-1 justify-between px-4">
              {/* Buscar */}
              <div className="flex flex-1">
                <form className="flex w-full md:ml-0" action="#" method="GET">
                  <label htmlFor="search-field" className="sr-only">
                    Search
                  </label>
                  <div className="relative w-full text-gray-400 focus-within:text-gray-600">
                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center">
                      <MagnifyingGlassIcon className="h-5 w-5" aria-hidden="true" />
                    </div>
                    <input
                      id="search-field"
                      className="block h-full w-full border-transparent py-2 pl-8 pr-3 text-gray-900 placeholder-gray-500 focus:border-transparent focus:placeholder-gray-400 focus:outline-none focus:ring-0 sm:text-sm"
                      placeholder="Buscar"
                      type="search"
                      name="search"
                    />
                  </div>
                </form>
              </div>
              {/* Notificación y usuario */}
              <div className="ml-4 flex items-center md:ml-6">
                <button
                  type="button"
                  className="rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">View notifications</span>
                  <BellIcon className="h-6 w-6" aria-hidden="true" />
                </button>

                {/* Profile dropdown */}
                <Menu as="div" className="relative ml-3">
                  <div>
                    <Menu.Button className="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                      <span className="sr-only">Open user menu</span>
                      <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-indigo-600 hover:bg-indigo-700">
                        <Tooltip title={`${auth.userID || auth.userName}`} placement='left'>
                          <span className="font-medium leading-none text-white">{getLetterName(auth.userName)}</span>
                        </Tooltip>
                      </span>
                    </Menu.Button>
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      {userNavigation.map((item) => (
                        <Menu.Item key={item.name}>
                          {({ active }) => (
                            <button
                              id={item.id}
                              className={classNames(
                                active ? 'bg-gray-100' : '',
                                'w-full text-left block px-4 py-2 text-sm text-gray-700'
                              )}
                              onClick={() => handleProfile(item.id)}
                            >
                              {item.name}
                            </button>
                          )}
                        </Menu.Item>
                      ))}
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          </div>
          {/* FIN DIV BANNER */}

          {/* COMPONENTE */}
          {
            currentNav &&
            <Breadcrumb page={currentNav} />
          }
          <main className='flex flex-col flex-grow'>
            {children}
          </main>

        </div>
        {/* FIN DIV BANNER & CONTENT */}

      </div>
    </>
  )
}
